import { IModel } from '@/@types/models/model';
import coreFields from './helpers/coreFields';

const Zalbe: IModel = {
  title: 'NekretnineZalbe',
  apiPath: 'ena/porez-na-nekretnine/zalbe',
  exportFileName: 'porez_nakretnine_zalbe',
  forms: {
    default: {
      fields: [
        'obveznik_id',
        'naplatni_prostor_id',
        'datum_podnosenja',
        'tekst',
        'status_zalbe_id',
        'napomena'
      ],
    },
    insert: {
      fields: [
        { source: 'obveznik_id', readonly: false },
        { source: 'naplatni_prostor_id', readonly: false },
        'datum_podnosenja',
        'tekst',
        'status_zalbe_id',
        'napomena'
      ]
    }
  },
  listViews: {
    default: {
      fields: [
        'obveznik_id',
        'naplatni_prostor_id',
        'datum_podnosenja',
        'tekst',
        'status_zalbe_id',
        'napomena',
        'created_on',
        'modified_on',
        'docs'
      ],
      hidden: ['id', 'created_on', 'modified_on'],
    },
    obveza_zalbe: {
      fields: [
        'datum_podnosenja',
        'tekst',
        'status_zalbe_id',
        'napomena',
        'docs'
      ]
    },
    exportExcel: {
      fields: [
        'obveznik_id',
        'naplatni_prostor_id',
        'datum_podnosenja',
        'tekst',
        'status_zalbe_id',
        'napomena'
      ]
    }
  },
  fields: [
    coreFields.id,
    coreFields.gid,
    coreFields.active,

    coreFields.docs,

    coreFields.created_on,
    coreFields.modified_on,
    coreFields.modified_by,

    {
      title: 'ID Nekretnine',
      source: 'nekretnina_id',
      ttoken: 'ena:nekretnine_zalbe.nekretnina_id',
      type: 'wholenum',
      filter: true,
      readonly: true,
    },
    {
      title: 'Status zalbe',
      source: 'status_zalbe_id',
      ttoken: 'ena:nekretnine_zalbe.status_zalbe',
      type: 'picker',
      filter: true,
      subModel: {
        apiPath: 'ena/porez-na-nekretnine/statusi-zalba',
        format: '{label}',
      },
      validation: {
        required: true
      },
      readonly: false,
      width: 'full'
    },
    {
      title: 'tekst',
      source: 'tekst',
      ttoken: 'ena:nekretnine_zalbe.tekst',
      type: 'multiline',
      rows: 3,
      maxRows: 5,
      validation: {
        required: true
      },
      filter: true,
      width: 'full'
    },
    {
      title: 'Datum podnosenja',
      source: 'datum_podnosenja',
      ttoken: 'ena:nekretnine_zalbe.vrijeme_podnosenja',
      type: 'date',
      validation: {
        required: true
      },
      filter: true,
      width: 'full'
    },
    {
      title: 'Napomena',
      source: 'napomena',
      ttoken: 'ena:nekretnine.napomena',
      type: 'text',
      filter: true,
      width: 'full'
    },
    {
      title: 'Obveznik',
      source: 'obveznik_id',
      ttoken: 'ena:nekretnine.obveznik',
      type: 'picker',
      subModel: {
        apiPath: 'ena/porez-na-nekretnine/obveznici',
        format: '{label}',
      },
      validation: {
        required: true
      },
      readonly: true,
      filter: true,
      width: 'full'
    },
    {
      title: 'Nekretnina',
      source: 'naplatni_prostor_id',
      ttoken: 'ena:nekretnine.nekretnina',
      type: 'picker',
      subModel: {
        apiPath: 'ena/porez-na-nekretnine/naplatni-prostori',
        format: '{label}',
      },
      validation: {
        required: true
      },
      readonly: true,
      filter: true,
      width: 'full'
    },
  ],
};

export default Zalbe;